import React from 'react';
import styled from 'styled-components';
import RadioButton from '../../../../Common/BaseComponentWrappers/MotifRadio';
import PrintViewKnowledgeDescription from './PrintViewKnowledgeDescription';
import {GetCardTypeForBody} from '../../../../../util/utils';

function PrintViewRadioButtonBody(props) {
	const {body} = props;

	const formBodyBorder = GetCardTypeForBody(body);

	const mainBodyKey = `form-body-${body.id}-radio`;

	return (
		<StyledPrintViewRadioButtonBody className={`StyledPrintViewRadioButtonBody ${formBodyBorder}`}>
			{body && body.id > 0 && <PrintViewKnowledgeDescription body={body} bodyDescription={body.name} />}
			<section className="SectionBodyData PrintViewRadioButtonBodyData" id={body.id}>
				{body.optionsAndResponses &&
					body.optionsAndResponses.map((data) => {
						return (
							/*<section className="section-radio">*/
							<RadioButton
								key={`${mainBodyKey}-option-${data.bodyOptionId}`}
								radioId={data.bodyOptionId}
								radioName={data.id}
								isChecked={data.bodySelectedOptionId === 1}
								labelValue={data.bodyOptionText}
								title={data.bodyOptionText}
								disabled
								isAresView
								isPrint
							/>
							/*</section>*/
						);
					})}
			</section>
		</StyledPrintViewRadioButtonBody>
	);
}

export default PrintViewRadioButtonBody;

const StyledPrintViewRadioButtonBody = styled.section`
	.section-radio {
		margin-top: var(--px-5);
	}
	.SectionBodyData {
		margin-top: var(--px-10);
		display: block !important;
		&.PrintViewRadioButtonBodyData {
			margin: var(--px-10) 0 var(--px-10) var(--px-30);
		}
	}
`;
